import React, { useCallback } from "react";
import * as S from "./ExtendedTabs.styles";
import { ExtendedTabId, IExtendedTab } from "./ExtendedTabs.types";
import { ArrowDownMicroIcon } from "@ubnt/icons";
import { useTranslation } from "hooks/useTranslation";
import { absoluteAssetUrl, getOptimizedImageUrl } from "util/assets";
import { useSiteSettings } from "context/SiteSettingsContext";
import { getPath } from "util/route";
import { useHistory } from "react-router-dom";

export const ExtendedTabs = ({
  tabs,
  activeTabId,
  onSelectTab,
}: {
  tabs: IExtendedTab[];
  activeTabId: ExtendedTabId | string;
  onSelectTab?: (tab: IExtendedTab) => void;
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { routes } = useSiteSettings();

  const handleTabClick = useCallback(
    (tab: IExtendedTab) => {
      return !!tab.href
        ? history.replace({
            pathname: getPath(routes, tab.href),
            // @ts-expect-error this is custom property for scroll behavior
            skipScrollToTop: true,
          })
        : onSelectTab(tab);
    },
    [history, onSelectTab, routes],
  );

  return (
    <S.TabWrapper>
      {tabs.map((tab, index) => (
        <S.Tab
          key={`extended-tab-${tab.id}-${index}`}
          $isActive={activeTabId === tab.id}
          onClick={() => handleTabClick(tab)}
        >
          <S.ImageWrapper>
            <S.TabImage
              src={getOptimizedImageUrl(absoluteAssetUrl(tab.image), 128)}
              srcSet={`${getOptimizedImageUrl(absoluteAssetUrl(tab.image), 256)} 2x`}
              alt={t(tab.label)}
              loading="lazy"
              decoding="async"
            />
          </S.ImageWrapper>

          <S.Label>{t(tab.label)}</S.Label>

          {activeTabId === tab.id && (
            <S.ActiveIndicator>
              <ArrowDownMicroIcon size={25} variant="fill" />
            </S.ActiveIndicator>
          )}
        </S.Tab>
      ))}
    </S.TabWrapper>
  );
};
